import {getService, getServiceAuthorized, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';
const PurchaseService = {};

PurchaseService.myPurchaseItems = () => AxiosRequest.get(
    `/${route.pointAccrual}/api/v1/salesNode/get/Sale/All/Info/Data`,
  );

PurchaseService.reasonsApprovalAndRejection = (decision, hierId) => AxiosRequest.get(
    `/${route.pointAccrual}/api/v1/salesNode/sale/reasons/${decision}/${hierId}`,
);
PurchaseService.acceptOrReject = (payload) =>  AxiosRequest.post(
  // `/${route.pointAccrual}/api/v2/salesNode/purchase/accept/or/reject`,
  `/${route.pointAccrual}/api/v3/salesNode/purchase/accept/or/reject`,
  payload,
)
PurchaseService.purchaseApprovalWeb = (saleId) => AxiosRequest.get(
  `/${route.pointAccrual}/api/v1/salesNode/sale/list/${saleId}`,
)

PurchaseService.myPurchaseItemsUsingFilter = (
  brandId,
  mobNum,
  fromDate,
  toDate,
  listType,
  dealer_id,
  influencerName,
  payload,
  limit,
  pageNo,
) => AxiosRequest.post(
  `/${
      route.pointAccrual
    }/api/v5/salesNode/get/purchase/All/Info/Data?brand_id=${brandId}&mobile=${mobNum}&dealer_id=${dealer_id}&from_date=${fromDate}&is_verified=${listType}&to_date=${toDate}&name_contractor=${influencerName}&limit=${limit}&offset=${
      (pageNo - 1) * limit
    }`,
  payload,
);

PurchaseService.conversionFactor = () => AxiosRequest.get(
  `/${route.pointAccrual}/api/v1/salesNode/consumption/rate`,
)
PurchaseService.getDealersForSaleApproval = (saleId ) => AxiosRequest.get(
  `/${route.pointAccrual}/api/v1/salesNode/get/all/sale/approval/dealers/${saleId}`,
)
PurchaseService.editPurchase = (saleId, payload ) => AxiosRequest.post(
  `/${route.pointAccrual}/api/v1/salesNode/update/sale/approval/${saleId}`,
  payload,
)
// PurchaseService.autoSuggestion = (mobile, contactId='') => AxiosRequest.get(
//   `/${route.pointAccrual}/api/v1/salesNode/sale/get/all/customers?mobile=${mobile}&contact_id=${contactId}`
// )
PurchaseService.autoSuggestion = (mobile, contactId = '') =>
  AxiosRequest.get(
    contactId
      ? `/${route.pointAccrual}/api/v1/salesNode/sale/get/all/customers?mobile=${mobile}&contact_id=${contactId}`
      : `/${route.pointAccrual}/api/v1/salesNode/sale/get/all/customers?mobile=${mobile}`
  );
PurchaseService.getBrandForPurchase = (token) => getServiceAuthorized(
  `/${route.registration}/api/v3/masterNode/all/brands/user?`,
  token
);
PurchaseService.getPurchaseApprovalDealer = () => AxiosRequest.post(
  `/${route.pointAccrual}/api/v2/salesNode/get/purchase/All/Info/dealers`,
);

PurchaseService.getPreviousDealersForSaleApproval = (saleId) =>
  AxiosRequest.get(
    `/${route.pointAccrual}/api/v2/salesNode/get/dealers/previousPurchase/purchasApproval/${saleId}?`
  );

  PurchaseService.salesTSEGetSearchedDealer = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/salesNode/get/dealers/dealersSearch/purchasApproval?`,
      payload
    );

  PurchaseService.updateAddress = (payload) =>
    AxiosRequest.post(
      `/${route.pointRedemption}/api/v1/orders/verify-address`,
      payload
    );

  PurchaseService.revokePurchase = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v1/pointsNode/revoke/approval`,
      payload
    );

    PurchaseService.selfieApprovalReasons = (query) =>
      AxiosRequest.get(
        `/${route.pointAccrual}/api/v1/salesNode/selfie/accept/or/reject/reasons?accept_or_reject=${query}`,
    );

    PurchaseService.selfieAcceptReject = (payload) =>
      AxiosRequest.post(
        `/${route.pointAccrual}/api/v1/salesNode/selfie/accept/or/reject`,
        payload
    );

    PurchaseService.selfieReupload = (payload) =>
      AxiosRequest.post(
        `/${route.pointAccrual}/api/v1/salesNode/selfie/reupload`,
        payload
    );


  PurchaseService.myPurchaseAlliedItemsUsingFilter = (
    brandId,
    mobNum,
    fromDate,
    toDate,
    listType,
    dealer_id,
    influencerName,
    payload,
    limit,
    pageNo,
) =>
  AxiosRequest.post(
    `/${
      route.pointAccrual
    }/api/v1/alliedProductNode/get/purchase/All/Info/Data?brand_id=${brandId}&mobile=${mobNum}&dealer_id=${dealer_id}&from_date=${fromDate}&is_verified=${listType}&to_date=${toDate}&name_contractor=${influencerName}&limit=${limit}&offset=${
      (pageNo - 1) * limit
    }`,
    payload
  );

  PurchaseService.acceptOrRejectAllied = (payload) =>
  AxiosRequest.post(
    `/${route.pointAccrual}/api/v1/alliedProductNode/purchase/accept/or/reject`,
    payload,
  );

  PurchaseService.getDateRange = () =>
    AxiosRequest.get(
      `/${route.pointAccrual}/api/v1/pointsNode/getDateRange?`,
  );



export default PurchaseService;